import { render, staticRenderFns } from "./InspectionDevices.vue?vue&type=template&id=0be1a7f6&scoped=true&"
import script from "./InspectionDevices.vue?vue&type=script&lang=ts&"
export * from "./InspectionDevices.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionDevices.vue?vue&type=style&index=0&id=0be1a7f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1a7f6",
  null
  
)

export default component.exports